var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.578 4.92822H0V15.7688H3.578V4.92822Z",
    fill: "#1E1B2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.324 5.05535C13.286 5.04353 13.25 5.03072 13.21 5.01987C13.162 5.00903 13.114 5.00016 13.065 4.99228C12.875 4.95483 12.667 4.92822 12.423 4.92822C10.337 4.92822 9.014 6.42324 8.578 7.00074V4.92822H5V15.7688H8.578V9.85575C8.578 9.85575 11.282 6.14434 12.423 8.87025C12.423 11.3035 12.423 15.7688 12.423 15.7688H16V8.45334C16 6.81547 14.861 5.45054 13.324 5.05535Z",
    fill: "#1E1B2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 3.44927C2.7165 3.44927 3.5 2.67713 3.5 1.72464C3.5 0.772146 2.7165 0 1.75 0C0.783502 0 0 0.772146 0 1.72464C0 2.67713 0.783502 3.44927 1.75 3.44927Z",
    fill: "#1E1B2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn2);
export default __webpack_public_path__ + "static/media/linkedIn2.faebfc1ae6ca6ad0ca6f28a2d80aeaaa.svg";
export { ForwardRef as ReactComponent };